// extracted by mini-css-extract-plugin
module.exports = {"progressBarComponent":"ProgressBar_progressBarComponent__1Mq-a","gray":"ProgressBar_gray__2-B4d"};